/**
 * Russian Translations (Русский)
 */

import type { Translations } from '../types';

export const ru: Translations = {
  language: 'ru',
  languageName: 'Русский',

  common: {
    demo: 'ДЕМО',
    privacy: 'Конфиденциальность',
    terms: 'Условия',
  },

  privacy: {
    title: 'Политика конфиденциальности',
    whatWeStore: 'Что мы храним',
    whatWeStoreDesc:
      'Мы временно обрабатываем геометрию лица для оценки возраста. Изображения и биометрические шаблоны не сохраняются после проверки.',
    whatWeDont: 'Что мы не храним',
    whatWeDontDesc:
      'Мы не храним фотографии, видео или биометрические идентификаторы. Данные лица обрабатываются в браузере и немедленно удаляются.',
    whyWeUseIt: 'Зачем мы это используем',
    whyWeUseItDesc:
      'Оценка возраста помогает сайтам соблюдать возрастные ограничения без требования личных документов.',
    readFull: 'Прочитайте нашу полную',
    privacyPolicyLink: 'Политику конфиденциальности',
  },

  theme: {
    system: 'Система',
    light: 'Светлая',
    dark: 'Тёмная',
  },

  face: {
    noFace: 'Лицо не обнаружено',
    tooFar: 'Лицо слишком далеко',
    tooClose: 'Лицо слишком близко',
    offCenter: 'Лицо не по центру',
    poorLighting: 'Недостаточно света',
    good: 'Анализируем, не двигайтесь...',
    holdStill: 'Анализируем, не двигайтесь...',
    holdStillCountdown: 'Не двигайтесь... {count}',
    processing: 'Обработка...',
    looking: 'Лицо не обнаружено',
    centerFace: 'Лицо не по центру',
    moveCloser: 'Лицо слишком далеко',
    moveBack: 'Лицо слишком близко',
    keepInPosition: 'Держите позицию',
    perfect: 'Отлично',
    centerInFrame: 'Поместите лицо в кадр',
    outsideOval: 'Лицо за пределами овала',
  },

  liveness: {
    blink: {
      title: 'Моргните',
      hint: 'Медленно моргните один раз',
    },
    smile: {
      title: 'Улыбнитесь',
      hint: 'Покажите естественную улыбку',
    },
    lookLeft: {
      title: 'Поверните налево',
      hint: 'Медленно поверните голову налево',
    },
    lookRight: {
      title: 'Поверните направо',
      hint: 'Медленно поверните голову направо',
    },
    openMouth: {
      title: 'Откройте рот',
      hint: 'Широко откройте рот',
    },
    lookUp: {
      title: 'Посмотрите вверх',
      hint: 'Поднимите голову вверх',
    },
    lookDown: {
      title: 'Посмотрите вниз',
      hint: 'Опустите голову вниз',
    },
    raiseBrows: {
      title: 'Поднимите брови',
      hint: 'Поднимите брови',
    },
    improveLighting: {
      title: 'Улучшите освещение',
      hint: 'Перейдите в более освещённое место для продолжения',
    },
  },

  document: {
    selectType: 'Выберите тип документа',
    captureFront: 'Сфотографируйте переднюю сторону',
    captureBack: 'Сфотографируйте обратную сторону',
    processing: 'Обработка документа...',
    tips: {
      goodLighting: 'Обеспечьте хорошее освещение',
      flatSurface: 'Положите документ на ровную поверхность',
      allCorners: 'Убедитесь, что все углы видны',
      noGlare: 'Избегайте бликов и теней',
    },
    types: {
      passport: 'Паспорт',
      idCard: 'Удостоверение личности',
      driversLicense: 'Водительские права',
    },
  },

  ui: {
    continue: 'Продолжить',
    next: 'Далее',
    retry: 'Повторить',
    startOver: 'Начать заново',
    cancel: 'Отмена',
    success: 'Проверка Возраста Пройдена',
    failure: 'Проверка Возраста Не Пройдена',
    loading: 'Загрузка...',
    error: 'Произошла ошибка',
    permissionRequired: 'Требуется разрешение',
    cameraPermission: 'Требуется доступ к камере',
    goBack: 'Назад',
    switchCamera: 'Переключить камеру',
    completeVerification: 'Завершить',
    continueToId: 'Продолжить проверку документов',
  },

  errors: {
    cameraNotFound: 'Камера не найдена на этом устройстве',
    cameraPermissionDenied: 'Доступ к камере запрещён',
    cameraInUse: 'Камера используется другим приложением',
    cameraNotSupported: 'Камера не поддерживает необходимые настройки',
    cameraSecurityError: 'Камера требует HTTPS-соединение',
    networkError: 'Ошибка сети. Проверьте подключение.',
    timeout: 'Время ожидания истекло. Попробуйте снова.',
    invalidApiKey: 'Недействительный API-ключ',
    sessionExpired: 'Сессия истекла. Начните заново.',
    verificationFailed: 'Проверка не пройдена. Пожалуйста, попробуйте снова.',
    unknownError: 'Произошла непредвиденная ошибка',
    cameraAccessDeniedDetailed: 'Пожалуйста, разрешите доступ к камере для продолжения.',
    cameraNotFoundDetailed:
      'Камера не обнаружена. Пожалуйста, подключите камеру и попробуйте снова.',
    cameraInUseDetailed:
      'Камера используется другим приложением. Пожалуйста, закройте его и попробуйте снова.',
    cameraOverconstrained:
      'Камера не поддерживает запрашиваемое разрешение. Пробуем с настройками по умолчанию...',
    networkTimeout: 'Запрос занял слишком много времени. Проверьте подключение и попробуйте снова.',
    networkOffline: 'Вы, похоже, не в сети. Проверьте подключение к интернету.',
    apiGenericError: 'Что-то пошло не так. Попробуйте снова.',
    faceNotDetected: 'Пожалуйста, расположите лицо в рамке.',
    livenessFailed: 'Проверка живости не пройдена. Попробуйте снова.',
    documentCaptureFailed:
      'Не удалось сфотографировать документ. Обеспечьте хорошее освещение и попробуйте снова.',
    initializationFailed: 'Ошибка загрузки. Пожалуйста, обновите страницу и попробуйте снова.',
    modelLoadFailed:
      'Не удалось загрузить необходимые компоненты. Обновите страницу и попробуйте снова.',
    unexpectedError: 'Произошла непредвиденная ошибка. Попробуйте снова.',
    configError: 'Ошибка конфигурации. Обратитесь в службу поддержки.',
  },

  screens: {
    welcome: {
      title: 'Проверка возраста 18+',
      subtitle: 'Анонимная Проверка Возраста',
      startButton: 'Начать',
      secureNote: 'Безопасно и зашифровано',
      ageTechBy: 'Возрастные технологии от AppBouncer',
      waitingCamera: 'Ожидание доступа к камере',
      allowCamera: 'Разрешить доступ к камере',
      noBiometric: 'Биометрические данные не хранятся',
      loading: 'Загрузка...',
      loadingRequirements: 'Загрузка требований...',
    },
    permissions: {
      title: 'Загрузка ...',
      description: 'Пожалуйста, разрешите доступ к камере при запросе',
      allowButton: 'Разрешить доступ к камере',
      privacyNote: 'Ваши данные зашифрованы и защищены',
      goodLighting: 'Хорошее освещение!',
      goodLightingHint: 'Убедитесь, что ваше лицо хорошо освещено',
      getReady: 'Приготовьтесь',
      removeCoverings: 'Снимите маску',
      removeGlasses: 'Снимите очки',
    },
    facePosition: {
      title: 'Расположите лицо',
      hint: 'Лицо по центру',
      step: 'Шаг',
      stepOf: 'Шаг {current} из {total}',
      lookingForFace: 'Поиск лица...',
    },
    livenessCheck: {
      title: 'Проверка живости',
      followInstructions: 'Следуйте инструкциям',
      preparing: 'Подготовка...',
      complete: 'Живость Подтверждена!',
      actionAutoDetected: 'Действие будет определено автоматически',
      failed: 'Проверка живости не пройдена',
      failedDescription:
        'Мы не смогли проверить вашу живость. Пожалуйста, обеспечьте хорошее освещение, смотрите прямо в камеру и следуйте инструкциям на экране.',
      retryButton: 'Повторить Проверку Живости',
      restartButton: 'Начать Заново',
    },
    ageEstimation: {
      title: 'Не двигайтесь',
      analyzing: 'Анализ...',
      analyzingProgress: 'Анализ лица {current} из {total}...',
      estimatedAge: 'Предполагаемый возраст',
      holdStill: 'Не двигайтесь',
      verified: 'Возраст подтверждён',
      verificationUncertain: 'Возраст Неопределён',
      estimationComplete: 'Проверка возраста завершена',
      confirmedAge: 'Подтверждено {minAge}+ лет',
      couldNotConfirm: 'Не удалось подтвердить возраст {minAge}+',
      ageConfirmed: 'Возраст подтверждён',
      aboveMinimumAge: 'Вы соответствуете минимальному возрастному требованию',
      belowMinimumAge: 'Ниже минимального возраста',
      documentRequired: 'Требуется документ',
      uploadDocumentMessage:
        'Пожалуйста, загрузите действительный документ для подтверждения вашего возраста',
      idHint: 'Паспорт, водительские права или удостоверение личности',
      confidenceLevels: 'Достоверность по возрастному порогу',
      confidence: 'достоверность',
      years: 'лет',
      continueToId: 'Продолжить проверку документов',
      demoComplete: 'Демо-режим завершён. В продакшене вы были бы перенаправлены.',
      improveLighting: 'Улучшите освещение',
      improveLightingHint: 'Перейдите в более освещённое место для точных результатов',
    },
    documentSelect: {
      title: 'Выберите тип документа',
      description: 'Выберите тип удостоверения личности, которое вы будете сканировать',
      idCard: 'Удостоверение личности',
      idCardHint: 'Государственное удостоверение',
      passport: 'Паспорт',
      passportHint: 'Только страница с фото',
      driversLicense: 'Водительские права',
      driversLicenseHint: 'Действующие водительские права',
    },
    captureMode: {
      captureFrontSide: 'Сфотографировать лицевую сторону',
      captureBackSide: 'Сфотографировать обратную сторону',
      chooseMethod: 'Выберите способ захвата документа',
      useCamera: 'Использовать камеру',
      useCameraHint: 'Сделайте фото вашего документа',
      uploadFile: 'Загрузить файл',
      uploadFileHint: 'Выбрать с вашего устройства',
    },
    documentCamera: {
      frontSide: 'Лицевая сторона',
      backSide: 'Обратная сторона',
      positionInFrame: 'Расположите документ в рамке',
      scanFront: 'Сканировать лицевую сторону документа',
      scanBack: 'Сканировать обратную сторону документа',
      keepFlat: 'Держите документ ровно и при хорошем освещении',
      capturePhoto: 'Сделать фото',
    },
    documentPreview: {
      frontPreview: 'Предпросмотр лицевой стороны',
      backPreview: 'Предпросмотр обратной стороны',
      lookingGood: 'Отлично!',
      checkDetails: 'Убедитесь, что все данные чётко видны',
      imageQuality: 'Качество изображения',
      qualityGood: 'Хорошее',
      usePhoto: 'Использовать это фото',
      retakePhoto: 'Переснять фото',
    },
    documentCapture: {
      captureFront: 'Сфотографировать лицевую сторону',
      captureBack: 'Сфотографировать обратную сторону',
      alignDocument: 'Выровняйте документ в рамке',
      captureButton: 'Сфотографировать',
      retakeButton: 'Переснять',
      confirmButton: 'Подтвердить',
      frontSide: 'Лицевая сторона',
      backSide: 'Обратная сторона',
      positionDocument: 'Расположите документ в рамке',
      alignWithFrame: 'Выровняйте документ по рамке',
      positionFrontId: 'Расположите лицевую сторону ID',
      positionBackId: 'Расположите обратную сторону ID',
      scanFrontId: 'Сканировать лицевую сторону ID',
      scanBackId: 'Сканировать обратную сторону ID',
      positionWithinFrame: 'Расположите лицевую сторону в рамке',
      flipAndScan: 'Переверните ID и отсканируйте обратную сторону',
      goodLight: 'Хорошее освещение',
      flatSurface: 'Ровная поверхность',
      frontCaptured: 'Лицевая сторона снята',
      captureIdCard: 'Сфотографировать удостоверение',
      capturePassport: 'Сфотографировать паспорт',
      captureDriversLicense: 'Сфотографировать водительские права',
    },
    processing: {
      title: 'Обработка',
      description: 'Пожалуйста, подождите, пока мы обрабатываем',
      analyzingDocument: 'Анализ документа...',
      almostDone: 'Почти готово...',
      faceVerified: 'Лицо подтверждено',
      livenessConfirmed: 'Живость подтверждена',
      processingDocuments: 'Обработка документов...',
    },
    success: {
      title: 'Проверка возраста пройдена',
      description: 'Проверка возраста и живости завершена',
      redirecting: 'Перенаправление...',
      summary: 'Итог',
      faceMatch: 'Совпадение лица',
      liveness: 'Живость',
      age: 'Возраст',
      idDocument: 'Документ, удостоверяющий личность',
      pass: 'Пройдено',
      fail: 'Не пройдено',
      valid: 'Действителен',
      notApplicable: 'Н/Д',
      done: 'Готово',
      feedbackTitle: 'Пожалуйста, оцените ваш опыт',
      feedbackPlaceholder: 'Расскажите, как мы можем улучшить...',
      skip: 'Пропустить',
      submit: 'Отправить',
    },
    failure: {
      title: 'Проверка Возраста Не Пройдена',
      description: 'Не удалось завершить проверку. Пожалуйста, попробуйте снова.',
      tryAgainButton: 'Попробовать снова',
      leaveButton: 'Покинуть',
      attemptsLeft: 'Осталось {{count}} попыток',
      noAttemptsLeft: 'Попытки исчерпаны',
    },
    error: {
      title: 'Требуется настройка',
      description:
        'Некоторые обязательные параметры отсутствуют в URL. Пожалуйста, свяжитесь с администратором сайта.',
      missingParams: 'Отсутствующие параметры',
      requiredParams: 'Обязательные параметры',
      technicalDetails: 'Технические детали',
      urlMustInclude: 'URL должен содержать следующие параметры запроса:',
    },
    underage: {
      title: 'Возрастное требование не выполнено',
      description: 'Для доступа к этой услуге вам должно быть не менее {{minAge}} лет.',
    },
    consent: {
      title: 'Помогите Улучшить Проверку Возраста',
      description:
        'Разрешите AppBouncer собирать небольшое количество анонимизированных данных об использовании (например, захваты с камеры) для улучшения проверки возраста и резервных проверок. Ваши данные никогда не продаются и не передаются третьим лицам.',
      allowButton: 'Разрешить',
    },
    documentConsent: {
      title: 'Требуется Документ',
      description:
        'Для завершения проверки нам необходимо подтвердить ваш возраст по официальному документу. Вы согласны загрузить удостоверение личности?',
      allowButton: 'Продолжить с документом',
      declineButton: 'Отклонить',
      privacyNote: 'Ваш документ будет безопасно обработан и удалён после проверки.',
    },
    selfDeclaration: {
      title: 'Ваша дата рождения',
      description: 'Пожалуйста, введите дату рождения для продолжения',
      day: 'День',
      month: 'Месяц',
      year: 'Год',
      yourAge: 'Ваш возраст:',
      years: 'лет',
      confirmButton: 'Продолжить',
      months: {
        january: 'Январь',
        february: 'Февраль',
        march: 'Март',
        april: 'Апрель',
        may: 'Май',
        june: 'Июнь',
        july: 'Июль',
        august: 'Август',
        september: 'Сентябрь',
        october: 'Октябрь',
        november: 'Ноябрь',
        december: 'Декабрь',
      },
    },
  },

  lighting: {
    warning: 'Проблема с освещением',
    adjust: 'Отрегулируйте освещение',
    lowLight: 'Обнаружено слабое освещение',
    tooBright: 'Слишком ярко',
    poorContrast: 'Плохой контраст',
    improveLighting: 'Найдите лучшее освещение',
    moveToLighter: 'Перейдите в более освещённое место',
    videoNotReady: 'Видео не готово',
  },

  steps: {
    faceDetection: 'Распознавание лица',
    liveness: 'Проверка живости',
    age: 'Проверка Возраста',
    documentScan: 'Сканирование документа',
    selfDeclaration: 'Самодекларация',
  },

  status: {
    cameraStarted: 'Камера запущена',
    cameraReady: 'Камера готова',
    cameraAccessDenied: 'Доступ к камере запрещён',
    cameraError: 'Ошибка камеры',
    cameraNotAvailable: 'Камера недоступна',
    noFaceDetected: 'Лицо не обнаружено',
    livenessVerified: 'Живость подтверждена',
    livenessCheckFailed: 'Проверка живости не пройдена',
    verifyingAge: 'Проверка возраста...',
    processingDocument: 'Обработка документа...',
    documentProcessed: 'Документ успешно обработан',
    verificationCancelled: 'Проверка отменена',
    improveLightingForAge: 'Улучшите освещение для точных результатов',
    getReady: 'Приготовьтесь',
    preparingLiveness: 'Подготовка проверки живости...',
    uploadingSelfie: 'Загрузка селфи...',
    preparingUpload: 'Подготовка загрузки...',
    uploadingFront: 'Загрузка лицевой стороны документа...',
    uploadingBack: 'Загрузка обратной стороны документа...',
    processingDocuments: 'Обработка документов...',
    documentSubmissionFailed: 'Ошибка отправки документа. Попробуйте снова.',
    selectJpegOrPng: 'Пожалуйста, выберите изображение в формате JPEG или PNG',
    fileTooLarge: 'Файл слишком большой. Максимум 5 МБ.',
    errorReadingFile: 'Ошибка чтения файла',
    frontDocumentRequired: 'Требуется изображение лицевой стороны документа',
    verificationFailedClose: 'Проверка не пройдена. Вы будете перенаправлены.',
    verificationCompleteClose: 'Проверка завершена! Вы будете перенаправлены.',
    analyzingFace: 'Анализ лица...',
  },
};
